<template>
  <PopUp
    v-if="isProToFreePopupVisible"
    :max-height="90"
    close-button
    close-button-variant="black"
    @close="closeProToFreePopup"
  >
    <div class="upgrade-popup">
      <div class="upgrade-popup__image pro-to-free">
        <div class="text-over pro-to-free-over">Are you sure you want to downgrade?</div>
      </div>
      <div class="upgrade-popup__main-block">
        <div class="upgrade-popup__title">If you downgrade, you’ll lose access to these features:
        </div>
        <ul class="upgrade-popup__items">
          <li
            class="upgrade-popup__item"
            v-for="(benefit,index) in upgradeBenefits"
            :key="index"
          >
            <img
              class="item__icon"
              :src="benefit.icon"
              :alt="benefit.alt"
            >
            <div class="item__text">{{ benefit.text }}</div>
          </li>
        </ul>
        <a
          class="button-brand upgrade-popup__button"
          @click="paidTierPopupConfirmHandler(),closeProToFreePopup()"
        >Yes I’m sure
        </a>
        <div
          role="button"
          class="upgrade-popup__text"
          @click="closeProToFreePopup"
        >Not now
        </div>
      </div>
    </div>
  </PopUp>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import PopUp from '@/components/PopUp';

export default {
  name: 'ProToFreePopup',
  components: { PopUp },
  computed: {
    ...mapGetters({
      isProToFreePopupVisible: 'isProToFreePopupVisible',
      paidTierPopupConfirmHandler: 'paidTierPopupConfirmHandler',
    }),
    upgradeBenefits() {
      return [
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/customization.svg'),
          text: 'Page customisation',
          alt: 'Customization icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/tryb.svg'),
          text: 'Removing Tryb branding',
          alt: 'Tryb icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/access.svg'),
          text: '50GB storage space',
          alt: 'Upload icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/fees.svg'),
          text: 'Lower transaction fees',
          alt: 'Fees icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/build.svg'),
          text: 'Course building templates',
          alt: 'Build icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/mailchimp.svg'),
          text: 'Mailchimp integration',
          alt: 'Mailchimp icon',
        },
      ];
    },
  },
  methods: {
    ...mapMutations({
      closeProToFreePopup: 'closeProToFreePopup',
    }),
  },
};
</script>
